module.exports = __webpack_public_path__ + "static/media/risk_nobg.9979caa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/risk_nobg.png
// module id = 483
// module chunks = 0